import state from '@/store/modules/auctions/defaultState';

const actions = {
  async getMyAcvNegotiationsBuyingAuctions(
    {
      dispatch,
    },
    { page = 1 },
  ) {
    const auctions = await dispatch('auctions/getAuctionList', {
      apiMethod: 'getMyAcvNegotiationsBuyingAuctions',
      moduleKey: 'MyAcvNegotiationsBuying',
      numberOfLoaders: 10,
      page,
    }, {
      root: true,
    });
    return auctions;
  },
};

export default {
  state,
  actions,
};
